import { render, staticRenderFns } from "./PayOrder.vue?vue&type=template&id=21ebdba3&scoped=true&"
import script from "./PayOrder.vue?vue&type=script&lang=js&"
export * from "./PayOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ebdba3",
  null
  
)

export default component.exports